import { useCallback } from "react";

import { useDashboardLanguage } from "../context/DashboardLanguageContext";
import type { DashboardLanguage } from "../types";
import type { TranslationTree } from "../utils/translations/translationTypes";

type TranslationMap = Record<DashboardLanguage, TranslationTree>;

export function useDashboardTranslate<T extends TranslationMap>(map: T): (key: string) => string {
  const { language } = useDashboardLanguage();

  return useCallback(
    (key: string) => {
      const value = map[language]?.[key] ?? map.en?.[key];
      return typeof value === "string" ? value : key;
    },
    [language, map],
  );
}
